import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { sanitizeDocumento } from "../../../utils/documento";

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control?: any;
    error?: any;
    maxLength?: number;
    disabled?: boolean;
}

// O valor é gravado sem máscara (só letras e dígitos, em maiúsculas), para enviar o
// documento limpo ao backend. Ex.: "CU.R73.JA1/0001-56" -> "CUR73JA1000156"
// O maxLength vale para o valor limpo: aplicado direto no <input>, ele cortaria um
// documento colado com máscara ("12.ABC.345/01DE-35" viraria "12ABC34501D").

const inputDocumento: React.FC<IFormInput> = ({ id, name, label, control, error, maxLength, disabled }) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: renderChange, value, onBlur } }) => (
                <TextField
                    id={id}
                    value={value || ""}
                    onBlur={onBlur}
                    margin="normal"
                    size="small"
                    label={label}
                    variant="outlined"
                    error={!!error && !!error[name]}
                    helperText={!!error && error[name]?.message}
                    fullWidth
                    disabled={disabled}
                    onChange={(event) => renderChange(sanitizeDocumento(event.target.value).slice(0, maxLength))}
                />
            )}
        />
    );
};

export default inputDocumento;
